import { z } from 'zod';

// ---------------------------------------------------------------------------
// Completions
// ---------------------------------------------------------------------------

export const completionsBody = z.object({
  hub_id: z.string().uuid(),
  connection_id: z.string().uuid(),
  model: z.string(),
  prompt: z.string(),
  system_prompt: z.string().optional(),
  temperature: z.number().min(0).max(2).default(1),
});

// ---------------------------------------------------------------------------
// Inferred types
// ---------------------------------------------------------------------------

export type CompletionsBody = z.infer<typeof completionsBody>;

// ---------------------------------------------------------------------------
// Response types
// ---------------------------------------------------------------------------

/** POST / */
export interface CompletionsResponse {
  content: string;
  error?: string;
}
